import { Badge, Text } from "@merge-api/merge-javascript-shared";
import { AlertTriangle } from "lucide-react";

const FlagBanner = ({
  title,
  subtitle,
  color,
}: {
  title: string;
  subtitle: string;
  color: "orange" | "yellow" | "blue";
}) => (
  <div className="flex items-center gap-3 px-4 py-2.5 rounded-lg border border-gray-10 bg-white">
    <Badge color={color} className="flex-none flex items-center gap-1 whitespace-nowrap">
      <AlertTriangle size={11} />
      {title}
    </Badge>
    <Text variant="caption" className="text-gray-700">
      {subtitle}
    </Text>
  </div>
);

export default FlagBanner;
